export default __webpack_public_path__ + "static/media/ageb.58737fb4.png";